import React, {useEffect, useState} from "react";
import TopNavigation from "../components/TopNavigation";
import "./About.css";

// import background from "../assets/Landing-Page-Background.png"; // Replace with the actual file name

import micah_alyse from "../assets/micah-alyse-photo.png";
import micah_alyse_dive_deeper from "../assets/IMG_0649.png";
import micah_alyse_resume from "../assets/Micah-Alyse-Resume.pdf";

// Importing partner logos
import coliseumLogo from "../assets/coli_centennial_logo_headerwhite.png";
import stadiumLogo from "../assets/la-stadium-logo5-1.png";
import lhnlLogo from "../assets/lhnl-full-logo-white.png";
import libertyLogo from "../assets/libertyflamesb.png";
import unitLogo from "../assets/unitwhite.png";
import nikeLogo from "../assets/nike_PNG4.png";

const testimoniesData = [
    {
        text: "Micah is versatile and always delivers quality work. She has helped transform Outdoor Recreations branding and her work will help shape the department for years to come!",
        author: "Karlyn Moye",
        position: "Liberty University Outdoor Recreation Event Director",
    },
    {
        text: "Micah’s work is innovative and truly represents our brand. We were impressed by her creativity and professionalism throughout the entire process!",
        author: "Issa Ennab",
        position: "CTO, Co-Founder",
    },
    {
        text: "Thank you!! Everyone loves the designs and would be happy to send more work your way!",
        author: "Wayne",
        position: "US Cable Tours Orlando, FL",
    },
    {
        text: "She understands the consumer and builds her solutions around their mindset. Fantastic execution and dexterous in feminine, neutral and masculine motifs.",
        author: "Ryan Plane",
        position: "Art Director & Book Author",
    },
];

function About() {

    const [currentTestimony, setCurrentTestimony] = useState(0);

    // Automatically change testimony every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTestimony((prev) => (prev + 1) % testimoniesData.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="app">

            <TopNavigation/>

            <section id="about" className="about">
                <div className="about-container">
                    {/* Image and Text Row */}
                    <div className="about-row">
                        <img
                            src={micah_alyse}
                            alt="Micah Alyse Friedberg"
                            className="about-image"
                        />
                        <div className="about-text">
                            <h2>Micah Alyse Friedberg</h2>
                            <p>
                                I’m a passionate graphic designer who thrives on creating visually
                                compelling designs that tell a story and connect with people. With a
                                collaborative approach and an eye for detail, I specialize in bringing
                                ideas to life through thoughtful branding, clean aesthetics, and
                                creative problem-solving.
                            </p>
                            <p>
                                When I’m not designing, I enjoy playing soccer, camping, surfing, and
                                exploring new places for inspiration.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="partners" className="partners">
                <div className="partners-container">
                    <h2>previous partners</h2>
                    <div className="partners-grid">
                        <img src={lhnlLogo} alt="Love Has No Limits" className="large-logo"/>
                        <img src={nikeLogo} alt="Nike" className="small-logo"/>
                        <img src={unitLogo} alt="Unit" className="large-logo"/>
                        <img src={coliseumLogo} alt="LA Memorial Coliseum" className="small-logo"/>
                        <img src={stadiumLogo} alt="SoFi Stadium" className="large-logo"/>
                        <img src={libertyLogo} alt="Liberty University" className="small-logo"/>
                    </div>
                </div>
            </section>

            <section className="testimonies">
                <div className="testimony-container">
                    {/* Testimony Bubble */}
                    <div className="testimony-bubble">
                        <p>{testimoniesData[currentTestimony].text}</p>
                    </div>

                    {/* Testimony Author */}
                    <div className="testimony-author">
                        <h3>{testimoniesData[currentTestimony].author}</h3>
                        <p>{testimoniesData[currentTestimony].position}</p>
                    </div>
                </div>

                {/* Navigation Dots */}
                <div className="testimony-dots">
                    {testimoniesData.map((_, index) => (
                        <span
                            key={index}
                            className={`dot ${currentTestimony === index ? "active" : ""}`}
                            onClick={() => setCurrentTestimony(index)}
                        ></span>
                    ))}
                </div>
            </section>

            <section className="dive-deeper-section">
                <div className="content-container">
                    <div className="text-container">
                        <h2>dive <br/> deeper</h2>
                        <div className="action">
                            <p>check out</p>
                            <a href={micah_alyse_resume} target="_blank" rel="noopener noreferrer"  className="button">my resume</a>
                        </div>
                        <div className="action">
                            <p>more to explore on</p>
                            <a href="https://www.instagram.com/micahalysedesign/" target="_blank" rel="noopener noreferrer"
                               className="button">instagram</a>
                        </div>
                    </div>
                    <div className="image-container">
                        <img src={micah_alyse_dive_deeper} alt="Sample"/>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default About;

